import reducer from './reducers';

export { default as eventSagas } from './sagas';
export { default as eventActions } from './actions';
export * from './selectors';

export default reducer;


// WEBPACK FOOTER //
// ./src/state/modules/event/index.js